<template>
  <span
    class="BSCTag"
    :class="[`is-${type}`, { 'is-deletable': deletable }]"
    @click="clickTag"
  >
    <span>{{ label }}</span>
    <BSCIcon v-if="deletable" class="BSCTag-delete" icon="deleteIcon" />
  </span>
</template>

<script>
'use strict'

import BSCIcon from './BSCIcon'

export default {
  name: 'BSCTag',
  components: {
    BSCIcon
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickTag() {
      if (this.deletable) this.$emit('delete')
    }
  }
}
</script>
